import { render, staticRenderFns } from "./draftax.vue?vue&type=template&id=3db31eb8&scoped=true&"
import script from "./draftax.vue?vue&type=script&lang=js&"
export * from "./draftax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db31eb8",
  null
  
)

export default component.exports